import { connect } from 'react-redux'
import { IStoreState } from '../../types/index'
import ServiceViewHeader from '../../components/services/view/ServiceViewHeader'
import { getService } from '../../state/reducers/services'
import { getServiceProgram } from '../../state/reducers/service-program/service-program'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  let serviceProgram

  const service = getService(state, ownProps.routeProps.match.params.id)
  if (service && service.serviceProgram) {
    serviceProgram = getServiceProgram(state, service.serviceProgram)
  }

  return {
    serviceProgram,
    steps: state.serviceEdit.steps.list,
    serviceId: state.service.metadata.edit.serviceId,
    name: service ? service.name : '',
    routeProps: ownProps.routeProps
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceViewHeader)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceViewHeader.ts